<template>
  <div>
    <Form ref="settleForm" :model="settle" :rules="settleRules" inline :label-width="125" class="form-common">
      <Row>
        <FormItem label="申请人（经销商）" prop="cusName">
          <CusInput :load-data-enabled="false" v-model="settle.cusCode" :name.sync="settle.cusName"/>
        </FormItem>
        <FormItem label="申请日期">
          <DatePicker type="daterange" split-panels v-model="dateApply" placeholder="请选择申请日期"></DatePicker>
        </FormItem>
        <FormItem label="结算日期">
          <DatePicker type="daterange" split-panels v-model="date" placeholder="请选择结算日期"></DatePicker>
        </FormItem>
      </Row>
      <FormItem class="btn-groups">
        <div style="float: left;display: inline;margin-bottom: 10px">
          <Button type="primary" @click="handleQuery">查询</Button>
          <Button type="default" @click="handleResetForm">重置</Button>
          <Button type="default" @click="goToPage('salesSettlement')">结算</Button>
        </div>
        <div style="float: left;display: inline">
          <Button type="primary" @click="handleFile('salesSettlement', settle)">打印</Button>
          <Button type="primary" @click="handleClickExport">导出</Button>
        </div>

      </FormItem>
    </Form>
    <CTable :columns="columns" :data="close.list" :total="total" :current="settle.page" @change="change"
            :showPage="true" @on-select-change="onSettleSelectChange"/>
    <Form ref="closeForm" :model="close" inline :label-width="125">
      <FormItem prop="list">
      </FormItem>
      <Row>
        <Col span="8">
          <FormItem label="结算总计">
            <p class="form-static">{{ close.jszj }}</p>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <Modal
        v-model="editModel"
        title="修改"
        :loading="editModelLoading"
        @on-ok="handleClickEditModelOK">
      <Form :label-width="80">
        <FormItem label="编号">
          <Input v-model="editItem.docCode" disabled placeholder="请输入结算金额"></Input>
        </FormItem>
        <FormItem label="超市名称">
          <Input v-model="editItem.superName" disabled placeholder="请输入结算金额"></Input>
        </FormItem>
        <FormItem label="金额">
          <Input v-model="editItem.applyAmount" placeholder="请输入结算金额"></Input>
        </FormItem>
        <FormItem label="已结金额">
          <Input v-model="editItem.closedAmount" placeholder="请输入已结姐呢"></Input>
        </FormItem>
        <FormItem label="未结金额">
          <Input v-model="editItem.unsetAmount" placeholder="请输入未结金额"></Input>
        </FormItem>
        <FormItem label="结算金额">
          <Input v-model="editItem.settAmount" placeholder="请输入结算金额"></Input>
        </FormItem>
        <FormItem label="结算方式">
          <Select v-model="editItem.settType" placeholder="请输入结算方式">
            <Option v-for="item in settTypeList" :key="item.id" :value="item.code">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>

    </Modal>

  </div>
</template>

<script>
import CTable from '@/components/CTable'
import BtnEvent from '@/components/BtnEvent'
import {timeFormat, amountFormat, repalceGetParamsByObj} from '@/plugin/tool'
import {CusInput} from "../../components/CusInput";

export default {
  name: 'SalesSettleList',
  mixins: [BtnEvent],
  components: {
    CTable, CusInput
  },
  data() {
    return {
      settleSelectList: null,
      cusSelectVisible: false,
      editModelLoading: false,
      editItem: {},
      editModel: false,
      date: [],
      dateApply: [],
      settle: {
        status: "1",
        page: 1,
        pageSize: 20
      },
      cusList: [],
      settleRules: {},
      marketList: [],
      total: 0,
      queryData: [],
      settTypeList: [],
      close: {
        list: [],
        jszj: null
      },
      columns: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '编号',
        key: 'docCode',
        width: 180,
        render: (h, params) => {
          return h('div', [
            h('a', {
              on: {
                click: () => {
                  this.goToPage('salesAppliInfo', {docCode: params.row.docCode})
                },
              }
            }, params.row.docCode)
          ])
        }
      }, {
        title: '结算日期',
        key: 'updateTime  ',
        width: 120,
        render: (h, params) => {
          return h('span', timeFormat(params.row.updateTime, 'date'))
        }
      }, {
        title: '促销门店',
        key: 'superName',
        width: 200,
      }, {
        title: '产品系列',
        key: 'skuClassName',
        width: 120,
      }, {
        title: '费用项目',
        key: 'baseName',
        width: 120,
      }, {
        title: '金额',
        width: 120,
        key: 'applyAmount',
        render: (h, params) => {
          return h('span', amountFormat(params.row.applyAmount))
        }
      }, {
        title: '已结金额',
        width: 120,
        key: 'closedAmount',
        render: (h, params) => {
          return h('span', amountFormat(params.row.closedAmount))
        }
      }, {
        title: '未结金额',
        width: 120,
        key: 'unsetAmount',
        render: (h, params) => {
          return h('span', amountFormat(params.row.unsetAmount))
        }
      },
        // , {
        //     title: '结算金额',
        //     width: 120,
        //     key: 'settAmount',
        //     render: (h, params) => {
        //         return h('span', amountFormat(params.row.settAmount))
        //     }
        // }
        {
          title: '结算方式',
          width: 120,
          key: 'settType',
          render: (h, params) => {
            _.forEach(this.settTypeList, (value) => {
              if (value.code === params.row.settType) {
                params.row.settleType = value.name
                return false
              }
            })
            return h('div', params.row.settleType)
          }
        }, {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 160,
          render: (h, params) => {
            return h('div', [
              h('a', {
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除操作',
                      content: '<p>确定要删除吗?</p>',
                      loading: true,
                      onOk: () => {
                        console.log(params)
                        this.$Modal.remove();
                        this.$fetch('SalesSett/del', {id: params.row.id}).then(res => {
                          this.getList()
                          this.queryTableData()
                          this.$Message.success('删除成功');
                        })
                      }
                    });
                  }
                },
                style: {
                  marginLeft: "5px",
                  color: "#ff030a"
                }
              }, '删除')
            ])
          }
        }]
    }
  },
  created() {
    this.getList()
    // this.queryTableData()
  },
  methods: {
    handleResetForm() {
      this.settle.cusCode = null
      this.settle.cusName = null
      this.date = []
    },
    getList() {
      this.$fetch('MethodSett/getList', {type: '1'}).then(res => {
        this.settTypeList = res.data.list
      })
    },
    queryCus(value) {
      this.$fetch('SysCus/getCodeName', {
        cusName: value
      }).then(res => {
        this.cusList = res.data.list
      })
    },
    handleQuery() { // 查询表单校验
      console.log(123131)
      this.$refs.settleForm.validate((valid) => {
        if (valid) {
          this.settle.page = 1
          this.settle.startDate = timeFormat(this.date[0], 'date')
          this.settle.closeDate = timeFormat(this.date[1], 'date')
          this.settle.beginDate = timeFormat(this.dateApply[0], 'date')
          this.settle.endDate = timeFormat(this.dateApply[1], 'date')
          this.queryTableData()
        }
      })
    },
    queryTableData() { // 查询表格
      this.settle.type = '0'
      this.$fetch('SalesSett/getList', this.settle).then(res => {
        this.close = res.data
        // _.remove(this.close.list, value => { //只显示已结
        //   return value.status !== '1'
        // })
        this.total = res.data.total
      })
    },
    change(index) {
      this.settle.page = index
      this.queryTableData()
    },
    handleClickExport() {

      this.settle.startDate = timeFormat(this.date[0], 'date')
      this.settle.closeDate = timeFormat(this.date[1], 'date')
      window.location.href = window.location.origin + `/api/SalesSett/downSalesSettExcel?` + repalceGetParamsByObj(this.settle)

    },
    handleClickEditModelOK() {
      this.editModelLoading = true;
      this.$fetch('SalesSett/save', this.editItem, "POST").then(res => {
        this.$Message.success('修改成功');
        this.editModelLoading = false;
        this.$Modal.remove();
        this.getList()
        this.queryTableData()
      })
    }
    , handleCusSelect(cus) {
      this.cusSelectVisible = false
      this.settle.cusName = cus.cusName
      this.settle.cusCode = cus.cusCode
    },
    handleClickCusSelect() {
      this.cusSelectVisible = true
    },
    onSettleSelectChange(list) {
      this.settleSelectList = list;
    },
    /**
     * 生成凭证按钮
     */
    handleClickCreateCode() {
      if (!this.settleSelectList) {
        return;
      }
      let ids = "";
      _.forEach(this.settleSelectList, item => {
        ids = ids + item.id + ","
      });
      ids = ids.substring(0, ids.length - 1);
      this.$fetch("SalesSett/savePingZhen", {ids: ids})
          .then(res => {
            this.$Message.success("生成成功")
          })
    }
  }
}
</script>
